const IFRAME_URI = "https://connext-fd-gnbrate4fjhjb3f7.z01.azurefd.net/thirdpartycookie.html";
const TIMEOUT_MS = 5000;
export class BlockedThirdPartyCookiesQualifier {
    constructor() {
        this.key = "BlockedThirdPartyCookies";
    }
    async process() {
        try {
            const cookiesWork = await this.cookieTest(IFRAME_URI);
            return (!cookiesWork).toString();
        }
        catch (_a) {
            return "false";
        }
    }
    cookieTest(iFrameUri) {
        return new Promise((resolve) => {
            const expectedOrigin = new URL(iFrameUri).origin;
            let settled = false;
            const cleanup = () => {
                window.removeEventListener("message", messageHandler);
                if (document.body.contains(frame))
                    document.body.removeChild(frame);
            };
            const settle = (value) => {
                if (settled)
                    return;
                settled = true;
                cleanup();
                resolve(value);
            };
            // Timeout — resolve false (not blocked) if iframe never responds
            const timer = setTimeout(() => settle(false), TIMEOUT_MS);
            const messageHandler = (event) => {
                // Validate origin to prevent spoofing
                if (event.origin !== expectedOrigin)
                    return;
                clearTimeout(timer);
                try {
                    const data = JSON.parse(event.data);
                    settle(!!data.result);
                }
                catch (_a) {
                    settle(false);
                }
            };
            const frame = document.createElement("iframe");
            frame.src = iFrameUri;
            frame.sandbox = "allow-scripts allow-same-origin";
            frame.style.display = "none";
            window.addEventListener("message", messageHandler);
            frame.onload = () => {
                var _a;
                (_a = frame.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage(JSON.stringify({ test: "cookie" }), expectedOrigin);
            };
            frame.onerror = () => {
                clearTimeout(timer);
                settle(false);
            };
            document.body.appendChild(frame);
        });
    }
}
